import { formatLongString } from '@morpho-org/morpho-ts'
import { formatMarketName, UNKNOWN_SYMBOL } from '@morpho-org/ui-v6/utils'
import { abbreviateAddress } from '@repo/utils'
import { isAddressEqual, zeroAddress } from 'viem'

import type { TokenLabel } from '@/lib/transforms/tokenLabel'

import type { AllocationCapTarget } from './allocationHistory.contract'

export type MarketTarget = Extract<AllocationCapTarget, { kind: 'market' }>

/** The idle market has no collateral, and reads as its loan asset alone. */
export const marketCollateral = (target: MarketTarget) =>
  target.collateralToken === null || isAddressEqual(target.collateralToken.address, zeroAddress)
    ? null
    : target.collateralToken

export function getMarketSeriesName(target: MarketTarget, maxLength?: number): string {
  if (target.loanToken === null) return 'Unknown Market'
  const collateral = marketCollateral(target)
  const symbol = (token: TokenLabel) => formatLongString(token.symbol || UNKNOWN_SYMBOL, maxLength)
  return formatMarketName(symbol(target.loanToken), collateral === null ? null : symbol(collateral))
}

/** A cap whose target can't be named, such as a removed adapter's, reads as its short adapter address. */
export function getCapSeriesName(target: AllocationCapTarget): string {
  switch (target.kind) {
    case 'vault':
      return target.vault?.name ?? abbreviateAddress(target.adapter)
    case 'market':
      return getMarketSeriesName(target)
    case 'adapter':
      return abbreviateAddress(target.adapter)
  }
}
